//#region src/compute-unit-context.ts
/**
* The org-role slug that marks a token subject as an agent-runtime HOST (`admin/org-role.service.ts`
* `BUILTIN_ROLES`, granted by the operator to the `isAgentHost` service SA and to nothing else).
*
* Declared here so core-api's role catalogue, the operator's host enrolment and `federated-token.ts`
* bind ONE definition. The role SLUG is the contract; the DP's anchor principal UUID deliberately is NOT,
* because it is per-DP state a published SDK cannot keep correct.
*/
const AGENT_HOST_ROLE_SLUG = "platform-agent-runtime";
/**
* The org-role slug of the org's directory enroller (`admin/org-role.service.ts` `BUILTIN_ROLES`),
* which enrolls and revokes machine principals and declares agent hosts. The operator grants it to
* the org's enroller service principal and to nothing else.
*
* Declared beside {@link AGENT_HOST_ROLE_SLUG} so the two credential-granting built-in roles have one
* definition each (2026-10-01-dp-oidc-federation, R-012). `EXTERNAL_PRINCIPAL_REFUSED_ROLE_SLUGS` in
* `federated-token.ts` names both, and WS-3 and core-api refuse them on an `external` principal.
*/
const MACHINE_ENROLLER_ROLE_SLUG = "platform-machine-enroller";
//#endregion
export { AGENT_HOST_ROLE_SLUG, MACHINE_ENROLLER_ROLE_SLUG };

//# sourceMappingURL=compute-unit-context.js.map